import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconArrowLeftRight.c.svg?react';

export const IconArrowLeftRight = withIconWrapper(ReactComponent);
